<template>
  <div class="culture">
    <div class="title">
      企业文化
    </div>
    <div style="text-indent:2em;line-height:30px; padding-bottom:10px;">
      一个优秀的企业必须建设卓越的文化，建设具有丰厚的文化底蕴，具有较强的凝聚力和活力，具有较好的团队协作意识和创新意识，具有较强的抗风险能力和竞争能力的企业文化。企业文化是企业持续发展的源泉和动力，是建设“百年企业”的基石。龍之超集团作为顺德房地产行业的标杆企业，企业文化更是经过多年历史的摸索与沉淀，独特的领导风格与长久的企业发展历程融合而来，是企业珍贵的精神结晶。
    </div>
    <div>
      <div class="c_title">企业宗旨</div>
      <div class="txt">
        以人才为根本，以市场为导向，以诚信为保证，以服务为宗旨
      </div>
    </div>
    <div>
      <div class="c_title">企业精神</div>
      <div class="txt">
        <h4>团队精神</h4>
        以团队为荣。
        培养全局观念、提倡通力合作，提高向心力、凝聚力，保证公司高效率运转。公司的成败，与每名员工有密切的关联。每名员工都是资源，团结一心更是资源的无穷力量
      </div>
      <div class="txt">
        <h4>专业精神</h4>
        以专业为本。
        用扎实的理论基础、熟练的专业技能、全面的业务能力，在房地产市场上独占鳌头。每名员工必须具备专业的眼光和知识处理工作中遇到和可能遇到的所有问题。
      </div>
      <div class="txt">
        <h4>服务精神</h4>
        以服务为信。
        让服务成为一种习惯，要求每名员工要有服务意识，设身处地的站在客户的角度去思考、解决问题，客户的需求即是公司的需求，在诚信的基础上建立效率和成本优势，立足顺德，面向广东。
      </div>
      <div class="txt">
        <h4>奉献精神</h4>
        以奉献为乐。
        具有强烈的责任意识和奉献精神，勇于克服工作中遇到的挫折和压力。奉献精神的本质是忠诚，是职业道德的升华，其价值在于尽职尽责。
      </div>
    </div>
    <div>
      <div class="c_title">企业目标</div>
      <div class="txt">立足广东，致力于成为专业房产服务龙头企业</div>
    </div>
    <div>
      <div class="c_title">企业使命</div>
      <div class="txt">为客户创造生活 为社会创造价值</div>
    </div>
    <div>
      <div class="c_title">经营理念</div>
      <div class="txt">诚信 专业 高效 优质</div>
    </div>
    <div>
      <div class="c_title">企业价值观</div>
      <div class="txt">1、客户第一</div>
      <div class="txt">2、诚信如一</div>
      <div class="txt">3、专注唯一</div>
      <div class="txt">4、团结奋斗</div>
    </div>
    <div>
      <div class="c_title">企业愿景</div>
      <div class="txt">深耕顺德，立足广东，传承百年</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.title {
  font-size: 28px;
  text-align: center;
  padding: 20px 0;
}
.c_title {
  font-size: 20px;
  color: #025691;
  font-weight: bold;
  border-bottom: 1px dashed #f0f0f0;
  border-top: 1px solid #f0f0f0;
  line-height: 40px;
}
.txt {
  line-height: 35px;
  word-wrap: break-word;
}
</style>
